import script from "./ProductCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCategory.vue?vue&type=script&setup=true&lang=js"

import "./ProductCategory.vue?vue&type=style&index=0&id=1e182700&lang=css"

const __exports__ = script;

export default __exports__